import React, { FunctionComponent } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import { useQuery } from "@tanstack/react-query";
// import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

// import { fetch_all_with_count, fetch_all } from "../../lib/v31lib";
// import { loginAtom } from '../../../lib/auth';

// import Lenis from "lenis";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { gsap } from "gsap";

// @ts-ignore
import {ReactComponent as Arrow} from "../../../img/Argenco_pijl_eco_rgb.svg";
// @ts-ignore
import {ReactComponent as Be} from "../../../img/be.svg";
// @ts-ignore
import {ReactComponent as Nl} from "../../../img/nl.svg";

import {
  Box,
  CircularProgress,
  Divider,
  Grid,
} from '@mui/material';
// import {
//   WhiteSection
// } from '../../../components/v2/custom';
import {
  DarkGreenButton,
  LightGreenButton,
  TextButton,
  Typography
} from '../../../components/v2/styled';
import { ENABLE_DUTCH_MEMBERS } from '../../../flags';

// import { Benefit as Ben } from '../../models/Benefit';
// import { NewsItem as NI } from '../../models/NewsItem';
import { Guardian } from '../../../models/Guardian';
import { User } from '../../../models/User';

// const { DateTime } = require("luxon");

type Props = {
  setStep: (n:number) => void;
  user?: User;
  setUser: (u:User) => void;
  guardian?: Guardian;
  setGuardian: (u:Guardian) => void;
}

export const EmissionChoiceMinor: FunctionComponent<Props> = ({setStep, user, setUser, guardian, setGuardian}) => {
  // const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);









  const boxButton = (type: "dark"|"light"|"text"|"darknorotate", icon: any, label: string, onClick: () => void) => {
    return <Box sx={{
      borderRadius: 1,
      border: '2px solid transparent',
      borderColor: (type === "dark" || type === "darknorotate") ? theme.palette.primary.main : (type === "light" ? theme.palette.primary.light : 'transparent'),
      padding: 2,
      cursor: 'pointer',
      width: '300px',
      height: '175px',
      display: 'inline-block',
      margin: 1,
      // float: 'left',
      "&:hover": {
        borderColor: (type === "dark" || type === "darknorotate") ? theme.palette.primary.light : (type === "light" ? theme.palette.primary.main : "transparent"),
        "& svg": {
          color: (type === "dark" || type === "darknorotate") ? theme.palette.primary.light : (type === "light" ? theme.palette.primary.main : theme.palette.primary.light),
        },
        "& hr": {
          backgroundColor: (type === "dark" || type === "darknorotate") ? theme.palette.primary.light : (type === "light" ? theme.palette.primary.main : theme.palette.primary.light),
        },
        "& p": {
          color: (type === "dark" || type === "darknorotate") ? theme.palette.primary.light : (type === "light" ? theme.palette.primary.main : theme.palette.primary.light),
        }
      },
      ...(type === 'darknorotate' ? {
        "& svg": {
          width: '50px',
          height: '62px',
          marginBottom: -1
        }
      } : {}),
      ...(type === 'dark' ? {
        "& svg": {
          transform: "rotate(90deg)",
          width: '50px',
          height: '62px',
          marginBottom: -1
        }
      } : {}),
      ...(type === 'light' ? {
        "& svg": {
          width: '50px',
          height: '50px',
          marginBottom: 0.5
        }
      } : {})
    }} onClick={onClick}>
      {icon}
      {/* <PersonIcon sx={{
        color: type === "dark" ? theme.palette.primary.main : theme.palette.primary.light,
      }} /> */}
      <Divider sx={{
        backgroundColor: type === "dark" ? theme.palette.primary.main : (type === "light" ? theme.palette.primary.light : theme.palette.primary.main),
      }} />
      <Box sx={{
        width: '264px',
        height: '82px',
        display: 'table-cell',
        verticalAlign: 'middle',
        textAlign: 'center'
      }}>
        <Typography variant="body1" sx={{
          color: type === "dark" ? theme.palette.primary.main : (type === "light" ? theme.palette.primary.light : theme.palette.primary.main),
          // height: '52px',
          // lineHeight: '52px'
        }}>{label}</Typography>
      </Box>
    </Box>
  }
  
  return <>
    <Grid item xs={12} sx={{textAlign: 'center'}}>
      <Typography variant="h1" sx={{
        marginTop: 4,
        display: 'inline-block',
        // maxWidth: {
        //   xs: '100%',
        //   lg: '440px'
        // }
      }}>{t("nw.emission.choice_minor.title")}</Typography>
    </Grid>
    <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
      <Typography variant="subtitle1" html fuck_p_tags sx={{
        display: 'inline-block',
        // maxWidth: {
        //   xs: '100%',
        //   lg: '440px'
        // }
      }}>{t("nw.emission.choice_minor.subsection")}</Typography>
    </Grid>
    <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
      {/* <Box sx={{width: '100%', textAlign: 'center'}}> */}
      {boxButton("dark", <Arrow sx={{
        color:  theme.palette.primary.main,
        height: '50px',
        width: '50px'
      }} />, t("nw.emission.choice_me.new_member"), () => {
        setStep(16);
        window.scrollTo(0, 0);
        // @ts-ignore
        if (!!window.dataLayer) window.dataLayer.push({
          event: 'emission',
          eventProps: {
            category: 'buying_for_minor',
            action: 'is_a_member',
            label: 'success',
            value: 1
          }
        });
      })}
      {boxButton("darknorotate", <Be />, t("nw.emission.choice_me.existing_member"), () => {
        setStep(17);
        window.scrollTo(0, 0);
        // @ts-ignore
        if (!!window.dataLayer) window.dataLayer.push({
          event: 'emission',
          eventProps: {
            category: 'buying_for_minor',
            action: 'not_a_member',
            label: 'success',
            value: 1
          }
        });
      })}
      {ENABLE_DUTCH_MEMBERS && i18n.resolvedLanguage === 'nl' && <>
        {boxButton("darknorotate", <Nl />, t("nw.nl.emission.choice_me.dutch_member"), () => {
          setUser({...(user || {auth_token: '', email: ''}), country: "NL", is_dutch: true});
          setGuardian({...(guardian || {auth_token: '', email: ''}), country: "NL", is_dutch: true});
          setStep(52);
          window.scrollTo(0, 0);
          // @ts-ignore
          if (!!window.dataLayer) window.dataLayer.push({
            event: 'emission',
            eventProps: {
              category: 'buying_for_minor',
              action: 'dutch_member',
              label: 'success',
              value: 1
            }
          });
        })}
      </>}
      {/* </Box> */}
    </Grid>





    {/* <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
      <DarkGreenButton
        id="existing_member"
        label={t("nw.emission.choice_minor.existing_member")}
        onClick={() => {
          setStep(16);
          window.scrollTo(0, 0);
          // @ts-ignore
          if (!!window.dataLayer) window.dataLayer.push({
            event: 'emission',
            eventProps: {
              category: 'buying_for_minor',
              action: 'is_a_member',
              label: 'success',
              value: 1
            }
          });
        }}
        sx={{
          marginLeft: 1,
          marginRight: 1,
          marginTop: 1
        }}
      />
      <LightGreenButton
        id="new_member"
        label={t("nw.emission.choice_minor.new_member")}
        onClick={() => {
          setStep(17);
          window.scrollTo(0, 0);
          // @ts-ignore
          if (!!window.dataLayer) window.dataLayer.push({
            event: 'emission',
            eventProps: {
              category: 'buying_for_minor',
              action: 'not_a_member',
              label: 'success',
              value: 1
            }
          });
        }}
        sx={{
          marginLeft: 1,
          marginRight: 1,
          marginTop: 1
        }}
      />
      {ENABLE_DUTCH_MEMBERS && i18n.resolvedLanguage === 'nl' && (
        <LightGreenButton
          id="dutch_minor"
          label={t("nw.nl.emission.choice_minor.dutch_member")}
          onClick={() => {
            setUser({...(user || {auth_token: '', email: ''}), country: "NL", is_dutch: true});
            setStep(52);
            window.scrollTo(0, 0);
            // @ts-ignore
            if (!!window.dataLayer) window.dataLayer.push({
              event: 'emission',
              eventProps: {
                category: 'buying_for_minor',
                action: 'dutch_member',
                label: 'success',
                value: 1
              }
            });
          }}
          sx={{
            marginLeft: 1,
            marginRight: 1,
            marginTop: 1
          }}
        />
      )}
    </Grid> */}
    <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4, paddingRight: {xs: 0, md: 2.5}}}>
      <TextButton
        id="back_btn"
        label={t("nw.emission.forgot.cta_back")}
        onClick={() => {
          setStep(0);
          window.scrollTo(0, 0);
        }}
        sx={{
          marginLeft: 1,
          marginRight: 1,
          marginTop: 1
        }}
      />
    </Grid>
  </>;
}

